import { isEmpty } from 'utils/types';

import getHumanReadableFormattedTimes from 'utils/dateAndTimes/formatters/getHumanReadableFormattedTimes';
import { getDayDiff } from 'utils/dateAndTimes/methods/methods';
import moment from 'moment-timezone';

const getHumanReadableFormattedDateAndTimesForRecurring = ({
  valueFrom,
  valueTo,
  timezone,
  t,
  stopType,
  firstStopInJourney,
}) => {
  let formattedDate = '';
  if (
    ['dropoff', 'DROPOFF'].indexOf(stopType) >= 0 &&
    !isEmpty(firstStopInJourney)
  ) {
    const baseDate = moment(firstStopInJourney.time_from);
    baseDate.tz(firstStopInJourney.time_from_tz);

    const date = moment(valueFrom);
    date.tz(timezone);

    formattedDate = t(`dates:RelativeDates.${getDayDiff(baseDate, date)}`);
  }

  const formattedTimes = getHumanReadableFormattedTimes({
    valueFrom,
    valueTo,
    timezone,
  }).split(' - ');

  return t('dates:RelativeDateWithTime', {
    relative_date: formattedDate,
    time_from: formattedTimes[0],
    time_to: formattedTimes[1],
  });
};

export default getHumanReadableFormattedDateAndTimesForRecurring;
